// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-layout {
    display: grid;
    min-height: 100vh;
    grid-template-rows: auto 1fr;
    background-color: hsl(var(--hsl-page))
}
@media (min-width: 768px) {
    .portal-layout {
        grid-template-columns: auto 1fr;
        grid-template-rows: repeat(1, minmax(0, 1fr))
    }
}
`, "",{"version":3,"sources":["webpack://./src/portal.css"],"names":[],"mappings":"AACE;IAAA,aAA4F;IAA5F,iBAA4F;IAA5F,4BAA4F;IAA5F;AAA4F;AAA5F;IAAA;QAAA,+BAA4F;QAA5F;IAA4F;AAAA","sourcesContent":[".portal-layout {\n  @apply grid min-h-screen grid-rows-[auto_1fr] bg-page md:grid-cols-[auto_1fr] md:grid-rows-1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
